<template>
  <div>
    <div class="row pt-3 pb-3">
      <!-- CATEGORIES -->
      <div class="col-12 col-lg-3 pb-3">
        <i v-if="isLoggedIn" class="material-icons float-right pr-2 align-middle" data-toggle="modal" data-target="#categoryModal" @click="categoryModalSet(false, undefined, undefined)">create_new_folder</i>
        <h2 class="block-header" data-toggle="collapse" href="#categories" role="button" aria-expanded="false" aria-controls="conf">
          Категории
        </h2>
        <Categories :class="{ show : this.$store.getters.getWindowWidth() >= 768 }" class="collapse" id="categories" :categories="categories" :categoryActive="categoryActive" :configurationActive="configurationActive" :parent="undefined" @categoryModalSet="categoryModalSet" @categoryActiveSet="categoryActiveSet" @configurationActiveSet="configurationActiveSet"/>
        <button v-if="isLoggedIn" ref="showModal" type="button" class="d-none" data-toggle="modal" data-target="#categoryModal"></button>
        <div v-if="isLoggedIn" class="modal fade" id="categoryModal" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ categoryModalContext.title }}</h5>
                <button type="button" class="close" ref="categoryModalClose" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <input class="form-control" v-model="categoryModalContext.form.name">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger mr-auto" v-show="categoryModalContext.editMode" @click="categoryModalDelete">Удалить</button>
                <button type="button" class="btn btn-outline-primary" @click="categoryModalSave">Сохранить</button>
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Отменить</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- CONFIGURATOR -->
      <div class="col-12 col-lg-9 p-0" id="configurator">
        <Configurator ref="configurator" :configuration="configuration" :categoryActive="categoryActive" :configurationActive="configurationActive" @saveConfiguration="saveConfiguration" @saveConfigurationToBuffer="saveConfigurationToBuffer" @loadConfigurationFromBuffer="loadConfigurationFromBuffer" @deleteConfiguration="deleteConfiguration" :materials="materials"/>
      </div>
    </div>
    
    <!-- ORDER FORM -->
    <OrderForm :configuration="configuration"/>

    <hr v-if="isLoggedIn">

    <!-- CUT -->
    <Cutting v-if="isLoggedIn" :configuration="configuration" :orderActive="orderActive" :materials="materials"/>
    <!-- ORDERS -->
    <Orders v-if="isLoggedIn" :orders="claims" name="Заявки" :archive=false :orderActive="orderActive" @orderActiveSet="orderActiveSet" @saveOrder="saveOrder"/>
    <Orders v-if="isLoggedIn" :orders="orders" name="Заказы" :archive=false :orderActive="orderActive" @orderActiveSet="orderActiveSet" @saveOrder="saveOrder"/>
    <Orders v-if="isLoggedIn" :orders="archive" name="Архив" :archive=true :orderActive="orderActive" @orderActiveSet="orderActiveSet" @saveOrder="saveOrder" @loadArchive="loadArchive"/>
    <Materials v-if="isLoggedIn" :materials="materials"/>
    <!-- LOGIN -->
    <Login v-if="!isLoggedIn"/>
  </div>
</template>

<script>
import axios from 'axios';
import Categories from '../components/Categories.vue';
import Configurator from '../components/Configurator.vue';
import Login from '../components/Login.vue';
import Materials from '../components/Materials.vue';
import Orders from '../components/Orders.vue';
import OrderForm from "../components/OrderForm";
import Cutting from '../components/Cutting.vue';
import $ from 'jquery';

var configuration = {
  id: -1,
  name: 'Новое изделие',
  data: {
    yBound: true,
    topOpen: true,
    sections: [
      {x: 40, x0: 0, y: 20, yf: 20, y0: 0, z: 40, z0: 0, direction: ''},
    ],
    layers: {
      walls: 0,
      bottom: 1,
      top: 0,
      partitions: 0,
    },
    materials: {
      inside: -1,
      outside: -1,
    },
    pockets: [
      { direction: "left", inside: false, outside: false },
      { direction: "right", inside: false, outside: false },
      { direction: "front", inside: false, outside: false },
      { direction: "back", inside: false, outside: false },
      { direction: "bottom", inside: false, outside: false },
      { direction: "top", inside: false, outside: false },
    ],
    gripsHeight: 12,
    grips: 'bottom-top',
    gripsLength: 0,
    gripsExtra: false,
  },
};
export default {
  data() {
    return {
      categories: [],
      categoryModalContext: {
        category: {
          id: '',
          name: '',
          category: '',
        },
        form: {
          name: '',
        },
        parent: '',
        title: '',
        editMode: false,
      },
      categoryActive: {
        id: -1,
        name: '',
      },
      configurationActive: {
        id: -1,
        name: '',
      },
      configuration: JSON.parse(JSON.stringify(configuration)),
      configurationBuffer: JSON.parse(localStorage.getItem('configurationBuffer')) || JSON.parse(JSON.stringify(configuration)),
      claims: [],
      orders: [],
      archive: [],
      orderActive: {},
      materials: [],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn();
    },
  },
  methods: {
    categoryModalSet(editMode, category, parent) {
      this.categoryModalContext.editMode = editMode;
      this.categoryModalContext.parent = parent;
      this.categoryModalContext.category = { name: '' };
      this.categoryModalContext.form = { name: '' };
      if (editMode) {
        this.categoryModalContext.category = category;
        this.categoryModalContext.form.name = category.name;
        this.categoryModalContext.title = 'Редактировать категорию: ' + category.name;
      } else {
        this.categoryModalContext.title = 'Добавить категорию';
        if (category != undefined) {
          this.categoryModalContext.title += ' к ' + category.name;
          this.categoryModalContext.category.category = category.id;
          this.categoryModalContext.parent = category;
        }
      }
      this.$refs.showModal.click();
    },
    categoryModalDelete() {
      axios.delete(`categories/${this.categoryModalContext.category.id}`).then(() => {
        if (this.categoryModalContext.parent != undefined) {
          this.categoryModalContext.parent.categories.splice(this.categoryModalContext.parent.categories.indexOf(this.categoryModalContext.category), 1);
        } else {
          this.categories.splice(this.categories.indexOf(this.categoryModalContext.category), 1);
        }
        this.$refs.categoryModalClose.click();
      });
    },
    categoryModalSave() {
      var data = this.categoryModalContext.category;
      data.name = this.categoryModalContext.form.name;
      if (this.categoryModalContext.editMode) {
        axios.put(`categories/${this.categoryModalContext.category.id}`, data).then((resp) => {
          this.categoryModalContext.category = resp.data;
          this.$refs.categoryModalClose.click();
        });
      } else {
        axios.post('categories', data).then((resp) => {
          if (this.categoryModalContext.parent != undefined) {
            this.categoryModalContext.parent.categories.push(resp.data);
          } else {
            this.categories.push(resp.data);
          }
          this.$refs.categoryModalClose.click();
        });
      }
    },
    categoryActiveSet(category) {
      this.orderActive = {};
      this.configurationActive = {
        id: -1,
        name: '',
      };
      this.categoryActive = category;
    },
    configurationActiveSet(configuration) {
      this.orderActive = {};
      this.categoryActive = {
        id: -1,
        name: '',
      };
      axios.get(`configurations/${configuration.id}`).then((resp) => {
        this.configurationActive = resp.data;
        this.configuration = JSON.parse(JSON.stringify(resp.data));
      });
    },
    orderActiveSet(order) {
      this.configurationActive = {
        id: -1,
        name: '',
      };
      this.categoryActive = {
        id: -1,
        name: '',
      };
      this.configuration = {
        id: order.configuration ? order.configuration.id : -1,
        name: '',
        data: JSON.parse(JSON.stringify(order.data)),
      };
      this.orderActive = order;
    },
    saveConfiguration(configuration) {
      var data = {
        name: configuration.name,
        data: configuration.data,
      }
      if (this.categoryActive.id >= 0) {
        data.category = this.categoryActive.id;
        axios.post('configurations', data).then((resp) => {
          this.categoryActive.configurations.push(resp.data);
        });
      } else if (this.configurationActive.id >= 0) {
        data.id = this.configurationActive.id;
        data.category = this.configuration.category;
        axios.put(`configurations/${this.configurationActive.id}`, data).then((resp) => {
          this.configurationActive.name = resp.data.name;
          var category = this.findCategory(this.configurationActive.category, {id: -1, categories: this.categories});
          category.configurations.forEach(configuration => {
            if (configuration.id == this.configurationActive.id) {
              configuration.name = this.configurationActive.name;
            }
          });
        });
      }
    },
    saveConfigurationToBuffer() {
      this.configurationBuffer = JSON.parse(JSON.stringify(this.configuration));
      localStorage.setItem('configurationBuffer', JSON.stringify(this.configuration));
    },
    loadConfigurationFromBuffer() {
      this.configuration.data = JSON.parse(JSON.stringify(this.configurationBuffer.data));
      this.configuration.forse_reload = true;
    },
    deleteConfiguration() {
      axios.delete(`configurations/${this.configurationActive.id}`).then(() => {
        var category = this.findCategory(this.configurationActive.category, {id: -1, categories: this.categories});
        category.configurations.splice(category.configurations.indexOf(this.configurationActive), 1);
        this.configuration = configuration;
        this.categoryActiveSet(category);
      });
    },
    findCategory(id, currentCategory) {
      if (id == currentCategory.id)
        return currentCategory;
      else {
        for (var i = 0; i < currentCategory.categories.length; i++) {
          var result = this.findCategory(id, currentCategory.categories[i]);
          if (result !== false)
            return result;
        }
        return false;
      }
    },
    saveOrder(order) {
      var data = {
        comment_admin: order.comment_admin,
      }
      if (order.ready_at != "")
        data.ready_at = order.ready_at;
      if (order.status < 0)
        data.is_active = false;
      else
        data.status = order.status;
      axios.patch(`orders/${order.id}`, data).then(() => {
        order.changed = false;
        var index = -1;
        for (let i = 0; i < this.claims.length; i++)
          if (this.claims[i].id == order.id)
            index = i;
        if (index >= 0)
          this.claims.splice(index, 1);
        index = -1;
        for (let i = 0; i < this.orders.length; i++)
          if (this.orders[i].id == order.id)
            index = i;
        if (index >= 0)
          this.orders.splice(index, 1);
        index = -1;
        for (let i = 0; i < this.archive.length; i++)
          if (this.archive[i].id == order.id)
            index = i;
        if (index >= 0)
          this.archive.splice(index, 1);

        if (order.status == 0) {
          this.claims.unshift(order);
        } else if (order.status == 1) {
          this.orders.unshift(order);
        } else if (order.status == 2) {
          this.archive.unshift(order);
        }
      });
    },
    loadArchive() {
      axios.get('orders?status=2').then((resp) => {
        this.archive = resp.data;
      });
    },
    recursiveConfigurationSearch(category, id) {
      var result = false;
      category.configurations.forEach(configuration => {
        if (configuration.id == id) {
          this.configurationActiveSet(configuration);
          $(`#category_${category.id}`).removeClass('hide');
          $(`#category_${category.id}`).addClass('show');
          result = true;
        }
      })
      if (result == true)
        return result;
      category.categories.forEach(c => {
        var found = this.recursiveConfigurationSearch(c, id);
        if (found == true) {
          $(`#category_${category.id}`).removeClass('hide');
          $(`#category_${category.id}`).addClass('show');
          return true;
        }
      });
      return false;
    },
  },
  mounted() {
    axios.get('categories').then((resp) => {
      this.categories = resp.data;
      this.$nextTick(() => {
        if (this.$route.hash.length >= 0)
            this.categories.forEach(category => this.recursiveConfigurationSearch(category, this.$route.hash.split('#configuration')[1]));
      })
    });
    axios.get('orders?status=0').then((resp) => {
      this.claims = resp.data;
      if (this.$route.query.id >= 0) {
        this.claims.forEach(claim => {
          if (claim.id == this.$route.query.id) {
            this.orderActiveSet(claim);
          }
        });
      }
    });
    axios.get('orders?status=1').then((resp) => {
      this.orders = resp.data;
      if (this.$route.query.id >= 0) {
        this.orders.forEach(order => {
          if (order.id == this.$route.query.id) {
            this.orderActiveSet(order);
          }
        });
      }
    });
    axios.get('materials').then((resp) => {
      this.materials = resp.data;
    });
  },
  components: {
    Categories,
    Configurator,
    Login,
    Materials,
    Orders,
    OrderForm,
    Cutting,
  },
}
</script>
